import React, { useState, useEffect } from "react";
import styles from "./style.module.scss";
import Modal from "../../../../components/modal";
import Button from "../../../../components/new-button";
import TextInput from "../../../../components/form/text-input";
import { cloneTemplate } from "../../../../../api";
import { toast } from "react-hot-toast";


const CloneModal = ({ isOpen, onClose, selectedTemplate, fetchData }) => {
  const [templateName, setTemplateName] = useState(selectedTemplate?.name);

  const handleCloneTemplate = async () => {
    const res = await cloneTemplate({
      id: selectedTemplate?.id,
      name: templateName,
    });
    if (res.status) {
      toast.success("Template cloned successfully");
      onClose();
      fetchData();
      return;
    }
    if (!res.status) {
      toast.error(res.message);
      return;
    }
  };

  useEffect(() => {
    if (isOpen) {
      setTemplateName(selectedTemplate?.name);
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="small"
      header="Clone Template"
    >

      <div className={styles.modalContent}>
        <TextInput
          label="Template Name"
          name="templateName"
          placeholder={`Enter template name`}
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
        />
      </div>

      <div className={styles.modalFooter}>
        <Button
          text="Cancel"
          onClick={onClose}
          variant="secondary"
        >
          <span>Cancel</span>
        </Button>
        <Button
          text="Clone"
          onClick={handleCloneTemplate}
          variant="primary"
        >
          <span>Clone</span>
        </Button>
      </div>
    </Modal>
  );
};

export default CloneModal;